import React from 'react';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to visible part of the UI for debugging in production
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // You can also log to an error monitoring service here
    console.error("Caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-display" style={{
          margin: '20px',
          padding: '20px',
          border: '1px solid #f55',
          borderRadius: '4px',
          backgroundColor: '#fee'
        }}>
          <h2>{this.props.t('boundary.heading')}</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary>{this.props.t('boundary.details')}</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default withTranslation('errors')(ErrorBoundary);
